import {
	Gender,
	IPedAppearanceValue,
	IPedFaceMorphValue,
	IPedParentsValue,
	PedFaceMorphSection,
} from '~/shared';
import { AbstractCharacterEditorService } from './AbstractCharacterEditorService';

export class CharacterEditorServiceStub extends AbstractCharacterEditorService {
	constructor() {
		super();

		this.parents.next([
			{ index: 0, name: 'Бенджамен', gender: Gender.MALE },
			{ index: 1, name: 'Даниэль', gender: Gender.MALE },
			{ index: 2, name: 'Джошуа', gender: Gender.MALE },
			{ index: 21, name: 'Ханна', gender: Gender.FEMALE },
			{ index: 22, name: 'Одри', gender: Gender.FEMALE },
			{ index: 23, name: 'Жасмин', gender: Gender.FEMALE },
		]);

		this.faceMorphs.next([
			{ index: 0, section: PedFaceMorphSection.Nose, name: 'Ширина носа' },
			{ index: 1, section: PedFaceMorphSection.Nose, name: 'Высота носа' },
			{ index: 2, section: PedFaceMorphSection.Nose, name: 'Длина носа' },
			{ index: 3, section: PedFaceMorphSection.Nose, name: 'Переносица' },
			{ index: 4, section: PedFaceMorphSection.Nose, name: 'Кончик носа' },
			{
				index: 5,
				section: PedFaceMorphSection.Nose,
				name: 'Смещение переносицы',
			},
			{ index: 6, section: PedFaceMorphSection.Brow, name: 'Высота бровей' },
			{ index: 7, section: PedFaceMorphSection.Brow, name: 'Ширина бровей' },
			{ index: 8, section: PedFaceMorphSection.Cheekbone, name: 'Высота скул' },
			{ index: 9, section: PedFaceMorphSection.Cheekbone, name: 'Ширина скул' },
			{
				index: 10,
				section: PedFaceMorphSection.Cheeks,
				name: 'Выпуклость щек',
			},
			{ index: 11, section: PedFaceMorphSection.Eyes, name: 'Открытость глаз' },
			{ index: 12, section: PedFaceMorphSection.Lips, name: 'Толщина губ' },
			{ index: 13, section: PedFaceMorphSection.Jaw, name: 'Ширина челюсти' },
			{ index: 14, section: PedFaceMorphSection.Jaw, name: 'Высота челюсти' },
			{
				index: 15,
				section: PedFaceMorphSection.Chin,
				name: 'Длина подбородка',
			},
			{
				index: 16,
				section: PedFaceMorphSection.Chin,
				name: 'Положение подбородка',
			},
			{
				index: 17,
				section: PedFaceMorphSection.Chin,
				name: 'Ширина подбородка',
			},
			{
				index: 18,
				section: PedFaceMorphSection.Chin,
				name: 'Форма подбородка',
			},
			{ index: 19, section: PedFaceMorphSection.Neck, name: 'Толщина шеи' },
		]);
	}

	public async setGenderValue(gender: Gender): Promise<void> {
		console.log('characterEditor:setGender', { gender });
	}

	public async setParentsValue(parents: IPedParentsValue): Promise<void> {
		console.log('characterEditor:setParents', { parents });
	}

	public async setFaceMorphValues(morphs: IPedFaceMorphValue[]): Promise<void> {
		console.log('characterEditor:setFaceMorphs', { morphs });
	}

	public async setAppearanceValue(
		appearance: IPedAppearanceValue,
	): Promise<void> {
		console.log('characterEditor:setAppearance', {
			appearance,
		});
	}

	public async exit(): Promise<void> {
		console.log('characterEditor:close');
	}
}
